import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ModalWindow from '@kenetto/uikit-modal'
import v4 from 'uuid/v4'

import { bindActionCreators } from 'redux'
import { notify } from 'reapop'
import { medicineActions } from '../../../../../redux/medicines'
import { immunizationsActions } from '../../../../../redux/immunizations'
import { currentSelectionActions } from '../../../../../redux/currentSelection'
import { adverseReactionActions } from '../../../../../redux/adverseReactions'

import ImmunizationInsertion from './ImmunizationInsertion'
import moment from 'moment'
import withPolyglot from '../../../../common/withPolyglot'
import { INSERTION_TYPE } from '../../../../../resources/utilities'

class ImmunizationInsertionContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      medicines: [],
      pathologies: [],
      modalIsOpen: false
    }
  }

  componentDidUpdate () {
    if (this.props.currentSelection.recommendation && !this.state.modalIsOpen) {
      this.toggleModal()
    } else if (this.props.currentSelection.insertionType && !this.state.modalIsOpen) {
      this.toggleModal()
    }
  }

  componentDidMount () {
    const {setMedicines} = this.props
    setMedicines()
  }

  toggleModal () {
    if (this.state.modalIsOpen) {
      this.props.removeSelectedRecommendation()
      this.props.removeEmptyInsertion()
    }
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  getNextImmunizationSequenceNumberForPathology (pathologyId) {
    const res = []
    this.props.immunizations.forEach(immuno => {
      immuno.protoInfo.forEach(info => {
        if (info.pathology.id === pathologyId) {
          res.push(immuno)
        }
      })
    })
    return res.length + 1
  }

  handleAdverseReactionSubmit (reaction, medicine) {
    const id = v4()
    this.setState({
      submittedAdverseReactionId: id
    })
    this.props.addAdverseReaction({id, medicineCode: medicine.code, ...reaction})
    this.props.notify({
      message: this.props.translate('submittedAdverseReaction', true, 'alerts'),
      status: 'info',
      dismissible: true,
      dismissAfter: 5000,
      position: 'bl',
      closeButton: true,
      allowHTML: true,
      buttons: []
    })
  }

  handleSubmit (immunizationData, adverseReactionData) {
    const medicine = this.props.medicines.data.find(med => med.code === immunizationData.medicine)
    const protoInfo = []
    const adverseReactionId = v4()
    const hasAdverseReaction = immunizationData.adverseReaction === 'positive'
    medicine.targetDiseases.forEach(id => {
      const seqNumber = this.getNextImmunizationSequenceNumberForPathology(id)
      const pathology = this.props.protocolEntries.find(entry => entry.pathology.id === id).pathology
      protoInfo.push({
        seqNumber,
        status: 'ONTIME',
        pathology: {
          id: pathology.id,
          name: pathology.name,
          displayKey: pathology.displayKey
        }
      })
    })
    const date = moment(immunizationData.date || new Date()).format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ')
    const immunizationId = v4()
    this.props.addImmunization({
      id: immunizationId,
      date,
      professional: 'facb097f-5858-4faf-8c59-52cc243f7f22',
      observations: immunizationData.observations,
      medicineCode: medicine.code,
      protoInfo,
      adverseReactionId: hasAdverseReaction ? adverseReactionId : undefined,
      type: medicine.type
    })

    // Button to select inserted ->
    //    buttons: [{
    //      name: 'Ver Detalhes',
    //      primary: false,
    //      onClick: () => {
    //        this.props.selectImmunization(immunizationId)
    //      }
    //    }]
    this.props.notify({
      message: this.props.translate('addedShot', true, 'alerts'),
      status: 'success',
      dismissible: true,
      dismissAfter: 5000,
      position: 'bl',
      closeButton: true,
      allowHTML: true,
      buttons: []
    })
    if (hasAdverseReaction) {
      this.props.addAdverseReaction({id: adverseReactionId, medicineCode: medicine.code, ...adverseReactionData})
      this.props.notify({
        message: this.props.translate('submittedAdverseReaction', true, 'alerts'),
        status: 'success',
        dismissible: true,
        dismissAfter: 5000,
        position: 'bl',
        closeButton: true,
        allowHTML: true,
        buttons: []
      })
    }
    this.toggleModal()
  }

  render () {
    const {currentSelection, medicines, protocolEntries, patientBirthDate} = this.props
    const { insertionType } = currentSelection
    const currentType = INSERTION_TYPE.getAppropriateType(insertionType)
    const availablePathologies = []
    let selectedPathology
    if (protocolEntries) {
      protocolEntries.forEach(entry => availablePathologies.push(entry.pathology))
      const entry = protocolEntries.find(entry => entry.pathology.id === currentSelection.pathology)
      if (entry) {
        selectedPathology = entry.pathology.id
      }
    }
    // TODO the title must be a whole text for each option
    if (currentSelection.insertionType || selectedPathology) {
      return <ModalWindow
        width={'small'}
        title={this.props.translate(
          `${currentSelection.insertionType === INSERTION_TYPE.IMMUNOGLOBULIN ? 'immunoglobulinInsertion' : 'vaccineInsertion'}`,
          true,
          'immunizationInsertion'
        )}
        toggleModal={this.toggleModal.bind(this)}
        modalIsOpen={this.state.modalIsOpen}>
        {/* availablePathologies */}
        {/* availableMedicines */}
        {/* handleSubmit */}
        {/* insertionType */}
        {/* selectedPathologies */}
        {/* selectedRecommendation */}
        <ImmunizationInsertion
          patientBirthDate={patientBirthDate}
          handlePreviousImmunizationSubmit={this.handleSubmit.bind(this)}
          availableMedicines={medicines.data}
          availablePathologies={availablePathologies}
          handleSubmit={this.handleSubmit.bind(this)}
          insertionType={currentType || 'vaccine'}
          selectedPathology={selectedPathology}
          selectedRecommendation={null} />
      </ModalWindow>
    }
    return null
  }
}

ImmunizationInsertionContainer.propTypes = {
  setMedicines: PropTypes.func.isRequired,
  addImmunization: PropTypes.func.isRequired,
  currentSelection: PropTypes.object,
  protocolEntries: PropTypes.array,
  medicines: PropTypes.object
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    notify,
    selectImmunization: currentSelectionActions.selectImmunization,
    setMedicines: medicineActions.setMedicines,
    addImmunization: immunizationsActions.addImmunization,
    removeSelectedRecommendation: currentSelectionActions.removeSelectedRecommendation,
    removeEmptyInsertion: currentSelectionActions.removeEmptyInsertion,
    addAdverseReaction: adverseReactionActions.add
  }, dispatch)
}

function mapStateToProps ({medicines, plan, patient, immunizations, currentSelection}) {
  return {
    patientBirthDate: patient.data.birthDate,
    immunizations: immunizations,
    medicines: medicines,
    protocolEntries: plan.protocolEntries,
    currentSelection
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withPolyglot(ImmunizationInsertionContainer, 'immunizationInsertion'))
